import React, { useState } from "react";
import { Box, Button, Chip, CircularProgress, Dialog, DialogContent, DialogTitle, Divider, Grid, Tab, Tabs, TextField, Typography } from "@material-ui/core";
import { CloudUpload } from "@material-ui/icons";
import swal from "sweetalert";
import { toast } from "react-toastify";
import { producaov2 } from "../../../../services/apis";
import { feedbackTextSuggestions } from "../../../../constants/projectApplications";

const validFeedbackFileExtensions = [
  '.pdf',
  '.xls',
  '.xlsx',
];

const FeedbackTypes = {
  file: 0,
  text: 1
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  if(value !== index) {
    return null;
  }

  return (
    <Box
      role="tabpanel"
      id={`vertical-tabpanel-${index}`}
      display="flex"
      flexGrow={1}
      p={3}
      {...other}
    >
      <Box width="100%">
        {children}
      </Box>
    </Box>
  );
}

function FileFeedback({ applicationPhaseID, feedbackUrl }) {
  const [selectedFile, setSelectedFile] = useState(null);

  const handleChangeFile = (e) => {
    e?.persist();

    const [file] = e.target.files;

    setSelectedFile(file);
  }

  return (
    <Box display="flex" flexDirection="column" alignItems="center" gridRowGap="1rem">
      <CloudUpload style={{ fontSize: "3rem" }} />
      <input name="type" value="file" style={{display: 'none'}} />
      <input name="feedback" id={`${applicationPhaseID}-feedback`} accept={validFeedbackFileExtensions?.join(',')} type="file" onChange={handleChangeFile} style={{display: 'none'}} />
      <label htmlFor={`${applicationPhaseID}-feedback`}>
        <Button variant="contained" color="primary" component="span" size="small">
          Enviar arquivo
        </Button>
      </label>
      {(feedbackUrl && !selectedFile) && (
        <Button component="a" href={feedbackUrl} target="_blank">Visualizar</Button>
      )}
      {selectedFile && (
        <Box textAlign="center">
          <Typography variant="body2">{selectedFile.name}</Typography>
        </Box>
      )}
    </Box>
  )
}

function TextFeedback({ defaultFeedback }) {
  const [helperText, setHelperText] = useState("");
  const [feedback, setFeedback] = useState(defaultFeedback || "");

  const handleSuggestionClick = ({ text = "", helper }) => {
    /**
     * Remover o espaço em branco das no inicio das linhas
     */
    setFeedback(text.replace(/^ +/gm, "").trim());
    setHelperText(helper);
  }

  return (
    <>
      <Box padding="0 0 2rem 0" display="flex" flexDirection="column" gridRowGap="0.75rem">
        <Typography variant="body2">Sugestões de texto</Typography>
        <Box display="flex" gridColumnGap="0.75rem">
          {feedbackTextSuggestions.map(({ name, text, helper }) => (
            <Chip label={name} variant="outlined" color="primary" onClick={() => handleSuggestionClick({ text, helper })} />
          ))}
        </Box>
      </Box>
      <input name="type" value="text" style={{display: 'none'}} />
      <TextField
        label="Feedback escrito"
        name="feedback"
        multiline
        variant="outlined"
        rowsMax={8}
        fullWidth
        defaultValue={defaultFeedback}
        value={feedback}
        onChange={e => setFeedback(e.target.value)}
        helperText={helperText}
      />
    </>
  )
}

export default function FeedbackSendOptionsModal({
  open = false,
  feedbackType = FeedbackTypes.file,
  defaultFeedback = "",
  applicationPhaseID,
  applicationID,
  onSubmit = () => {},
  onClose = () => {}
}) {
  const [tab, setTab]= useState(FeedbackTypes[feedbackType || "file"]);
  const [loadingFeedback, setLoadingFeedback] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData(e.target);

    const feedback = formData.get("feedback");
    const type = formData.get("type");

    const isFile = feedback instanceof File;

    if(!feedback || (isFile && feedback?.size === 0)) {
      swal("Feedback obrigatório", "Preencha um dos tipos de feedbacks", "warning");
      return;
    }

    const uploadFormData = new FormData();
    uploadFormData.append("feedback", feedback);
    uploadFormData.append("type", type);

    setLoadingFeedback(true);

    try {
      const response = await producaov2.post(`/admin/project-applications/${applicationID}/phases/${applicationPhaseID}/feedback-upload`, uploadFormData);

      onSubmit({
        feedback: response.data?.url ? response.data.url : response.data?.text,
        type
      });
      
      toast.success('Feedback enviado com sucesso');
    } catch(error) {
      console.log(error);
      toast.error('Houve um erro ao enviar o feedback');
    } finally {
      setLoadingFeedback(false);
    }

    return;
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>
        Escolha uma forma de feedback
        <Typography variant="body2">Ao escolher um tipo de feedback, o outro será removido</Typography>
      </DialogTitle>
      <DialogContent>
        <Box component="form" display="flex" flexDirection="column" gridRowGap="1rem" width="100%" onSubmit={handleSubmit}>
          <Box display="flex" flexDirection="column" flexGrow={1}>
            <Tabs
              textColor="primary"
              indicatorColor="primary"
              value={tab}
              onChange={(_, newTab) => setTab(newTab)}
            >
              <Tab color="primary" label="Arquivo" />
              <Tab color="primary" label="Texto" />
            </Tabs>
            <TabPanel index={FeedbackTypes.file} value={tab}>
              <FileFeedback
                feedbackUrl={feedbackType === "file" ? defaultFeedback : ""}
                applicationPhaseID={applicationPhaseID}
              />
            </TabPanel>
            <TabPanel index={FeedbackTypes.text} value={tab}>
              <TextFeedback defaultFeedback={feedbackType === "text" ? defaultFeedback : ""} />
            </TabPanel>
          </Box>
          <Box display="flex" justifyContent="flex-end" width="100%">
            <Button
              variant="contained"
              color="primary"
              type="submit"
              disabled={loadingFeedback}
            >
              {loadingFeedback ? <CircularProgress size={16} /> : "Enviar feedback"}
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}